import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'

export const SaveChangesButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'rgb(42, 128, 200)',
  minWidth: 100,
}))
